import { render, staticRenderFns } from "./WellnessMetricsChart.vue?vue&type=template&id=49e6f350&scoped=true&lang=pug&"
import script from "./WellnessMetricsChart.vue?vue&type=script&lang=js&"
export * from "./WellnessMetricsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e6f350",
  null
  
)

export default component.exports